var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPatient = function SvgPatient(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.2,0,0,0.2,2,1.9999)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 45.78,
    r: 9.843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.313,44.375L16.25,44.375C10.036,44.375 5,48.783 5,54.219C5,58.002 5,61.289 5,62.938C5,63.559 5.503,64.063 6.125,64.063L57.313,64.063C57.936, 64.063 58.438,63.559 58.438,62.938L58.438,45.5C58.438,44.878 57.936,44.375 57.313,44.375Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.813,23.749L34.064,23.749L34.064,32C34.064,32.622 34.567,33.125 35.189,33.125L42.312,33.125C42.934,33.125 43.437,32.622 43.437,32L43.437, 23.749L51.687,23.749C52.31,23.749 52.812,23.246 52.812,22.624L52.812,15.501C52.812,14.879 52.31,14.376 51.687,14.376L43.437,14.376L43.437, 6.125C43.437,5.503 42.934,5 42.312,5L35.189,5C34.567,5 34.064,5.503 34.064,6.125L34.064,14.376L25.813,14.376C25.191,14.376 24.688,14.879 24.688, 15.501L24.688,22.624C24.688,23.246 25.19,23.749 25.813,23.749Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.063,64.063L80.938,64.063C82.493,64.063 83.751,62.805 83.751,61.25C83.751,59.695 82.492,58.437 80.938,58.437L64.063,58.437C62.509,58.437 61.25, 59.695 61.25,61.25C61.25,62.805 62.509,64.063 64.063,64.063Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.563,34.25L86.563,66.875L6.125,66.875C5.503,66.875 5,67.378 5,68L5,93.875C5,94.496 5.503,95 6.125,95L12.313,95C12.935,95 13.438,94.496 13.438, 93.875L13.438,80.938L86.563,80.938L86.563,93.876C86.563,94.497 87.067,95.001 87.688,95.001L93.876,95.001C94.497,95 95,94.496 95,93.875L95,34.25C95, 33.628 94.497,33.125 93.875,33.125L87.687,33.125C87.064,33.125 86.563,33.628 86.563,34.25Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPatient, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/patient.8a0f4501.svg";
export { ForwardRef as ReactComponent };